<template>
  <main v-show="startRender">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1><img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
          공지사항
        </h1>
      </div>
      <div class="div_padding"></div>

      <!-- list -->
      <div class="list_div" id="notice">
        <div class="post_list">
          <div class="post" v-for="(notice, idx) in noticeList" :key="idx" @click="goToNoticeDetail(notice.nttId)">
            <div class="text">
              <img src="/images/basic/icon/Oval Copy 3.svg" width="1.2vw;" v-if="notice.newYn == 'Y'"><h3>{{ notice.nttSj }}</h3>
              <div class="con" v-html="notice.nttCn"></div>
              <span>{{ notice.ntceDay }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main> 
</template>

<script>
import { fetchNoticeList } from '@/api/notice'
export default {
  created() {
    fetchNoticeList({
      pageIndex: this.pageIndex,
      recordCntOnPage: 10
    })
    .then(({ data }) => {
      this.noticeList = data.resultList;
      this.listCnt = data.resultCnt
      this.startRender = true;
    })
  },
  mounted() {
    const offset = 400;
      window.addEventListener('scroll', () => { 
          if(window.$(window).scrollTop() > (window.$(document).height() - window.$(window).height()) - offset){
            this.fetchData();
          }
          /*
          if(parseInt(window.$(window).scrollTop()) == window.$(document).height() - window.$(window).height()){
            this.fetchData();
          }
          */
      });
  },
  data() {
    return {
      startRender:false,
      pageIndex: 1,
      listCnt: 0,
      noticeList: [],
    }
  },
  methods: {
    fetchData() {
      const listLength = this.noticeList.length
      if(this.listCnt > listLength) {
        this.pageIndex += 1
        fetchNoticeList({
           pageIndex: this.pageIndex,
           recordCntOnPage: 10
        })
        .then(({ data }) => {
          this.noticeList = [...this.noticeList, ...data.resultList]
        })
      }
    },
    goToNoticeDetail(nttId) {
      this.$router.push({
        path: '/noticeDetail', query : { nttId }
      })
    }
  },
}
</script>

<style scoped>
#more_board .post_list .text img {
  width: 1.2vw;
  top: 1.933vw;
  left: 0;
}
.myPost_wrapper .post_list {
  margin-left: 20px;
  padding-left: 0;
}

.myPost_wrapper .post_list .post .text {
  padding-left: 10px;
}

</style>